(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-shit-show"] && !Shopify.designMode) return;
  try {
    
(() => {
  async function start(root) {
    if(root.dataset.ready) return;
    root.dataset.ready='1';
    const labels=JSON.parse(root.querySelector('[data-labels]').textContent);
    const status=root.querySelector('[data-status]'),feed=root.querySelector('[data-feed]'),composer=root.querySelector('[data-composer]'),profileForm=root.querySelector('[data-profile-form]');
    const endpoint=root.dataset.endpoint;
    const gate=root.querySelector('[data-age-gate]'),ageForm=root.querySelector('[data-age-form]'),content=root.querySelector('[data-community-content]');
    gate.addEventListener('cancel',e=>e.preventDefault());
    const today=new Date();const cutoff=new Date(today.getFullYear()-18,today.getMonth(),today.getDate());
    const pad=n=>String(n).padStart(2,'0');const cutoffText=cutoff.getFullYear()+'-'+pad(cutoff.getMonth()+1)+'-'+pad(cutoff.getDate());
    ageForm.elements.birthday.max=cutoffText;
    gate.showModal();
    await new Promise(resolve=>{ageForm.onsubmit=e=>{e.preventDefault();const dob=ageForm.elements.birthday.value;if(!dob||dob>cutoffText||!ageForm.elements.ack.checked){root.querySelector('[data-age-error]').textContent=labels.age_error;return;}ageForm.reset();gate.close();content.hidden=false;content.inert=false;resolve();};});

    let me=null,view='feed',author=null,offset=0;
    if(!endpoint){root.querySelector('[data-setup]').hidden=false;return;}
    async function api(path,method='GET',body){const response=await fetch(endpoint+path,{method,credentials:'same-origin',headers:{'X-RSS-Adult':'1',...(body?{'Content-Type':'application/json'}:{})},body:body?JSON.stringify(body):undefined});const data=await response.json();if(!response.ok)throw new Error(data.error||labels.error);return data;}
    function el(tag,text,cls){const node=document.createElement(tag);if(text!==undefined)node.textContent=text;if(cls)node.className=cls;return node;}
    function button(text,action){const b=el('button',text);b.type='button';b.onclick=async()=>{b.disabled=true;try{await action();}catch(e){status.textContent=e.message;}finally{b.disabled=false;}};return b;}
    async function imageFile(file){if(!file)return null;if(file.size>10*1024*1024||!['image/jpeg','image/png','image/webp'].includes(file.type))throw new Error(labels.photo_error);const bitmap=await createImageBitmap(file);const scale=Math.min(1,1600/Math.max(bitmap.width,bitmap.height));const canvas=document.createElement('canvas');canvas.width=Math.round(bitmap.width*scale);canvas.height=Math.round(bitmap.height*scale);canvas.getContext('2d').drawImage(bitmap,0,0,canvas.width,canvas.height);bitmap.close();const data=canvas.toDataURL('image/jpeg',.8);if(data.length>1400000)throw new Error(labels.photo_error);return data;}
    async function refresh(reset=true){if(reset){offset=0;feed.replaceChildren();}const data=await api('/feed?view='+encodeURIComponent(view)+'&offset='+offset+(author?'&author='+encodeURIComponent(author):''));if(reset&&!data.posts.length)feed.append(el('p',labels.empty));for(const post of data.posts)renderPost(post);offset+=data.posts.length;root.querySelector('[data-more]').hidden=data.posts.length<20;}
    function renderPost(post){const card=el('article',undefined,'rss-card');const head=el('div',undefined,'rss-post-head');if(post.profile.avatar_url){const img=el('img',undefined,'rss-avatar');img.src=post.profile.avatar_url;img.alt='';head.append(img);}const user=button(post.profile.display_name||post.profile.handle,async()=>{view='profile';author=post.profile.id;profileForm.hidden=true;await refresh();});user.className='rss-user';const info=el('div');info.append(user,el('div',new Date(post.created_at).toLocaleString(), 'rss-date'));head.append(info);card.append(head,el('p',post.body,'rss-post-body'));if(post.image_url){const img=el('img',undefined,'rss-post-image');img.src=post.image_url;img.alt=post.body.slice(0,120);img.loading='lazy';card.append(img);}const actions=el('div',undefined,'rss-post-actions');actions.append(button((post.liked?labels.unlike:labels.like)+' · '+post.likes,async()=>{await api('/posts/'+post.id+'/like','POST');await refresh();}));if(me&&post.profile.id!==me.id)actions.append(button(post.following?labels.unfollow:labels.follow,async()=>{await api('/profiles/'+post.profile.id+'/follow','POST');await refresh();}));const comments=el('div');comments.hidden=true;actions.append(button(labels.comment,async()=>{comments.hidden=!comments.hidden;if(!comments.hidden){const data=await api('/posts/'+post.id+'/comments');comments.replaceChildren();for(const c of data.comments){const item=el('div',undefined,'rss-comment');item.append(el('strong',c.profile.display_name+': '),el('span',c.body));if(me&&(me.is_admin||me.id===c.profile.id))item.append(button(labels.delete,async()=>{if(confirm(labels.confirm_delete)){await api('/comments/'+c.id,'DELETE');item.remove();}}));comments.append(item);}if(me){const form=el('form',undefined,'rss-comment-form'),input=el('input');input.required=true;input.maxLength=2000;input.setAttribute('aria-label',labels.comment);const send=el('button',labels.comment);send.type='submit';form.append(input,send);form.onsubmit=async e=>{e.preventDefault();send.disabled=true;try{await api('/posts/'+post.id+'/comments','POST',{body:input.value});input.value='';comments.hidden=true;await refresh();}catch(err){status.textContent=err.message;}finally{send.disabled=false;}};comments.append(form);}}}));if(me)actions.append(button(labels.report,async()=>{const reason=prompt(labels.report_reason);if(reason){await api('/posts/'+post.id+'/report','POST',{reason});status.textContent=labels.saved;}}));if(me&&(me.id===post.profile.id||me.is_admin))actions.append(button(labels.delete,async()=>{if(confirm(labels.confirm_delete)){await api('/posts/'+post.id,'DELETE');await refresh();}}));if(me?.is_admin&&post.profile.id!==me.id)actions.append(button(labels.block,async()=>{if(confirm(labels.confirm_block)){await api('/profiles/'+post.profile.id+'/block','POST');await refresh();}}));card.append(actions,comments);feed.append(card);}
    root.querySelectorAll('[data-view]').forEach(b=>b.onclick=async()=>{view=b.dataset.view;author=view==='profile'?me?.id:null;profileForm.hidden=view!=='profile'||!me;try{await refresh();}catch(e){status.textContent=e.message;}});
    root.querySelector('[data-more]').onclick=()=>refresh(false).catch(e=>status.textContent=e.message);
    composer.onsubmit=async e=>{e.preventDefault();const submit=composer.querySelector('[type=submit]');submit.disabled=true;try{const image=await imageFile(composer.elements.photo.files[0]);await api('/posts','POST',{body:composer.elements.body.value,image});composer.reset();view='feed';author=null;await refresh();}catch(err){status.textContent=err.message;}finally{submit.disabled=false;}};
    profileForm.onsubmit=async e=>{e.preventDefault();const submit=profileForm.querySelector('[type=submit]');submit.disabled=true;try{const avatar=await imageFile(profileForm.elements.avatar.files[0]);me=await api('/me','PUT',{handle:profileForm.elements.handle.value,display_name:profileForm.elements.display_name.value,bio:profileForm.elements.bio.value,avatar});status.textContent=labels.saved;await refresh();}catch(err){status.textContent=err.message;}finally{submit.disabled=false;}};
    try{const data=await api('/me');me=data.profile;if(me)await api('/adult-ack','POST',{version:'2026-10-04',adult:true});composer.hidden=!me;root.querySelector('[data-signin]').hidden=!!me;if(me)for(const name of ['handle','display_name','bio'])profileForm.elements[name].value=me[name]||'';await refresh();}catch(e){status.textContent=e.message;}
  }
  document.querySelectorAll('[data-rss]').forEach(start);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-rss]').forEach(start));
})();

  } catch(e) { console.error(e); }
})();
})();
